import { SelectOption } from '@/components/Form/src/types'
import { basicTrainingEnums } from './BasicTrainingEnum'

const medicalSchool: SelectOption[] = [
  {
    label: 'CUHK',
    value: basicTrainingEnums.MedicalSchool.CUHK
  },
  {
    label: 'HKU',
    value: basicTrainingEnums.MedicalSchool.HKU
  }
  //   {
  //     label: 'Others',
  //     value: basicTrainingEnums.MedicalSchool.Others
  //   }
]

const status: SelectOption[] = [
  {
    label: 'Submitted by Trainee',
    value: basicTrainingEnums.Status.Submitted
  },
  // {
  //   label: 'Re-submitted by Trainee',
  //   value: basicTrainingEnums.Status.ReSubmitted
  // },
  // {
  //   label: 'Released by Admin',
  //   value: basicTrainingEnums.Status.Released
  // },
  {
    label: 'Endorsed',
    value: basicTrainingEnums.Status.Endorsed
  },
  {
    label: 'Rejected',
    value: basicTrainingEnums.Status.Rejected
  },
  {
    label: 'Approved',
    value: basicTrainingEnums.Status.Approved
  }
]

export const basicTrainingOptions = { medicalSchool, status }
